import axios from 'axios';

// 从本地存储获取API基础URL
const getBaseUrl = () => {
  
  const config = JSON.parse(localStorage.getItem('shipment_system_config') || '{}');
  return config.workerUrl || 'https://warehouseapi.proxypool.eu.org';
};

// 获取图片服务器地址
const _getImageServerUrl = () => {
  const config = JSON.parse(localStorage.getItem('shipment_system_config') || '{}');
  return config.imageUrl || 'https://imgapi.proxypool.eu.org';
};

// 创建axios实例
const api = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加认证令牌
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      // 尝试不同的认证头部格式
      config.headers['X-Auth-Token'] = token;
      // 有些服务器可能需要这种格式
      config.headers['x-auth-token'] = token;
    }
    console.log('发送请求:', config.url, config.headers);
    return config;
  },
  (error) => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理常见错误
api.interceptors.response.use(
  (response) => {
    console.log('收到响应:', response.config.url, response.status, response.data);
    return response;
  },
  (error) => {
    console.error('响应错误:', error.config?.url, error.message);
    if (error.response) {
      console.error('响应状态:', error.response.status);
      console.error('响应数据:', error.response.data);
      
      // 处理认证错误
      if (error.response.status === 401) {
        console.log('认证失败，清除token并重定向到登录页面');
        localStorage.removeItem('auth_token');
        window.location.href = '/login';
      }
    } else if (error.request) {
      // 请求已发送但没有收到响应
      console.error('没有收到响应:', error.request);
    }
    return Promise.reject(error);
  }
);

// 保存配置到本地存储
export const saveConfig = (config) => {
  localStorage.setItem('shipment_system_config', JSON.stringify(config));
  // 更新axios实例的baseURL
  api.defaults.baseURL = config.workerUrl || 'https://warehouseapi.proxypool.eu.org';
};

// 获取图片服务器URL
export const getImageServerUrl = () => {
  return _getImageServerUrl();
};

// 获取配置
export const getConfig = () => {
  return JSON.parse(localStorage.getItem('shipment_system_config') || '{}');
};

export default api;
